// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"a7660db8","239":"96e7d4bb"}[chunkId] + ".chunk.js";
};